// component
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const sidebarConfig = [
  // {
  //   title: 'dashboard',
  //   path: '/dashboard/app',
  //   icon: getIcon('eva:pie-chart-2-fill')
  // },
  {
    title: 'Select Project',
    path: '/dashboard/projects',
    icon: getIcon('emojione-monotone:globe-showing-americas')
  },
  // {
  //   title: 'Map',
  //   path: '/dashboard/map',
  //   icon: getIcon('eva:pie-chart-2-fill')
  // },
  {
    title: 'Consequences',
    path: '/dashboard/consequences',
    icon: getIcon('eva:pie-chart-2-fill')
  },
  {
    title: 'Buildings and Structures',
    path: '/dashboard/pushpins',
    icon: getIcon('eva:pie-chart-2-fill')
  },
];

export default sidebarConfig;
